import React from 'react';

import { GenericIconButton } from 'com-gyf-webcore-userinterfacecomponents';

const Funcion = (props) => {
    return <li className="inlineListItem">
        <div className="btn-group">
            <button type="button" className="btn-tag btn-tag-closable btn-tag-closable-left not-clickable">{props.funcion.Descripcion}</button>
            <button type="button" className="btn-tag btn-tag-closable btn-tag-closable-right"
                onClick={() => props.deleteFuncion(props.perfilId, props.funcion)}>
                <span key={"Func_" + props.funcion.Id + "-Prof_" + props.perfilId}
                    className="ti-close span-closable color-white"
                    title="Quitar función" />
            </button>
        </div>
    </li>
}

export default Funcion;